const VIDEOS_PATH = '/assets/videos';

export const testVideo = `${VIDEOS_PATH}/test.mp4`;
